module.exports = __webpack_public_path__ + "static/exo-v6-latin-regular-c6838ccb68d9f7845f4d1d98231f2f97.ttf";